// Web replacement for @react-native-clipboard/clipboard.
const Clipboard = {
  setString(text: string) {
    navigator.clipboard?.writeText(text).catch(() => {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      el.remove();
    });
  },
  async getString(): Promise<string> {
    try {
      return (await navigator.clipboard?.readText()) ?? '';
    } catch {
      return '';
    }
  },
};

export default Clipboard;
